import ecomerce from './assets/ecomerce.png'
import ice from './assets/ice shop.png'
import mart from './assets/mart.png'
import mobo from './assets/Betking2.png'
import Web1 from './assets/Web1.png'
 
export const ProductsData = [{
    name: 'Devhires',
    detail: 'divhire',
     img: Web1,
    type: 'react',
    source:'https://divehire.netlify.app'
},
 
{
    name: 'Design Port',
    detail: 'Super html',
     img: mart,
    type: 'react',
    source:'https://sweetmart.netlify.app/'

},
{
    name: 'Betwork',
    detail: 'Super html',
     img: mobo,
    type: 'html',
   
},
{
    name: 'E-commerce',
    detail: 'Super html',
     img: ecomerce,
    type: 'react',
    source:'https://eco-shopmart.netlify.app'
    
},
 
{
    name: 'ice-shop',
    detail: 'ice shop',
     img: ice,
    type: 'react',
    source:'https://mako-shop.netlify.app'
},
 
]